import { useEffect, useState } from 'react';

const QUERY = '(max-width: 1199px)';

export default function useNarrowPane() {
  const [narrow, setNarrow] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(QUERY).matches : false
  );

  useEffect(() => {
    const media = window.matchMedia(QUERY);
    const onChange = (event) => setNarrow(event.matches);
    setNarrow(media.matches);
    if (media.addEventListener) {
      media.addEventListener('change', onChange);
      return () => media.removeEventListener('change', onChange);
    }
    media.addListener(onChange);
    return () => media.removeListener(onChange);
  }, []);

  return narrow;
}
